/*
 * @Author: you
 * @Date: 2019-12-08 19:24:27
 * @LastEditTime: 2021-10-27 17:39:34
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\manageConfig\productManageMent\left.js
 * @Description: 管理配置左侧
 */

'use strict';
angular
    .module('productManageMentLeftModule', [
        'productMgrNewspaperLeftModule',
        'productMgrWebsiteLeftModule',
        'productMgrAppLeftModule',
        'televisionManageLeftModule',
        'broadcastManageLeftModule',
    ])
    .controller('productManageMentLeftController', [
        '$scope',
        '$state',
        '$location',
        '$q',
        'trsHttpService',
        'permissionService',
        function($scope, $state, $location, $q, trsHttpService, permissionService) {
            initStatus();

            // Tab 切换
            $scope.setTabSelected = function(moduleName) {
                moduleName = moduleName === 'paper' ? 'newspaper' : moduleName;
                if ($scope.status.isSelectedTab === moduleName) {
                    $scope.status.menuShow = $scope.status.menuShow !== true;
                    return;
                }
                $scope.status.isSelectedTab = moduleName;
                $scope.status.menuShow = true;
                var router = 'manageconfig.productmanage.' + moduleName;
                if (moduleName === 'website' || moduleName === 'app') {
                    delete $scope.selectedNode; // 清除站点选中
                    $state.go(router + '.site', {}, { reload: router + '.site' });
                } else {
                    $state.go(router, {}, { reload: router });
                }
                $scope.$root.narrowNavigation = false;
            };

            /**
             * [setTabSelectWeixn description]选择微信
             * @return  {[type]}  [return description]
             */
            $scope.setTabSelectWeixn = function() {
                $scope.status.isSelectedTab = 'weixin';
                $scope.status.menuShow = false;
                var router = 'manageconfig.productmanage.weixin';
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = true;
            };

            /**
             * [setTabSelectWeibo description]选择微博
             * @return  {[type]}  [return description]
             */
            $scope.setTabSelectWeibo = function() {
                $scope.status.isSelectedTab = 'weibo';
                $scope.status.menuShow = false;
                var router = 'manageconfig.productmanage.weibo';
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = true;
            };

            /**
             * [setTabSelectTrill description]选择抖音
             * @return  {[type]}  [return description]
             */
            $scope.setTabSelectTrill = function() {
                $scope.status.isSelectedTab = 'trill';
                $scope.status.menuShow = false;
                var router = 'manageconfig.productmanage.trill';
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = true;
            };

            /**
             * [setTabSelectBaijiahao description]选择百家号
             * @return  {[type]}  [return description]
             */
            $scope.setTabSelectBaijiahao = function() {
                $scope.status.isSelectedTab = 'baijiahao';
                $scope.status.menuShow = false;
                var router = 'manageconfig.productmanage.baijiahao';
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = true;
            };

            /**
             * [setTabSelectToutiaohao description]选择头条号
             * @return  {[type]}  [return description]
             */
            $scope.setTabSelectToutiaohao = function() {
                $scope.status.isSelectedTab = 'toutiaohao';
                $scope.status.menuShow = false;
                var router = 'manageconfig.productmanage.toutiaohao';
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = true;
            };

            /**
             * [setTabSelectQiehao description]选择企鹅号
             * @return  {[type]}  [return description]
             */
            $scope.setTabSelectQiehao = function() {
                $scope.status.isSelectedTab = 'qiehao';
                $scope.status.menuShow = false;
                var router = 'manageconfig.productmanage.qiehao';
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = true;
            };

            $scope.setTabSelect = function(tranch, flag) {
                $scope.status.isSelectedTab = tranch;
                $scope.status.menuShow = flag;
                var router = 'manageconfig.productmanage.' + tranch;
                $state.go(router, {}, { reload: router });
                $scope.$root.narrowNavigation = !flag;
            };

            /**
             * [initStatus description]
             *
             * @return  {[type]}  [return description]
             */
            function initStatus() {
                $scope.status = {
                    routerPathes: $location.path().split('/'),
                    menuShow: false,
                    isSite: $location.search().paper != undefined ? $location.search().paper : 0,
                    isChnlStatus: $location.path().split('/')[3],
                    order: ['paper', 'website', 'app', 'weixin', 'weibo', 'tv'],
                    isSelectedTab: $location.path().split('/')[3],
                    params: {
                        serviceid: 'mlf_mediasite',
                        methodname: 'queryWebSitesByMediaType',
                        // MediaType: '1' APP：1，网站：2，报纸：3，微信：4，微博：5
                    },
                    data: {
                        newspaper: {
                            selectedItem: 'newspapermgr',
                            isSelectedTab: false,
                        },
                        website: {
                            isSelectedTab: false,
                        },
                        app: {
                            isSelectedTab: false,
                        },
                        weixin: {
                            selectedItem: 'weixinmgr',
                            isSelectedTab: false,
                        },
                        weibo: {
                            items: '',
                            selectedItem: 'weibomgr',
                            isSelectedTab: false,
                        },
                        television: {
                            selectedItem: 'televisionmgr',
                            isSelectedTab: false,
                        },
                        broadcast: {
                            selectedItem: 'broadcastmgr',
                            isSelectedTab: false,
                        },
                        trill: {
                            selectedItem: 'trillmgr',
                            isSelectedTab: false,
                        },
                        baijiahao: {
                            selectedItem: 'baijiahaomgr',
                            isSelectedTab: false,
                        },
                        qiehao: {
                            selectedItem: 'qiehaomgr',
                            isSelectedTab: false,
                        },
                        toutiaohao: {
                            selectedItem: 'toutiaohaomgr',
                            isSelectedTab: false,
                        },
                        kuaishou: {
                            selectedItem: 'kuaishoumgr',
                            isSelectedTab: false,
                        }
                    },
                };
                $scope.data = {};
                permissionService.getPermissionData().then(function(data) {
                    $scope.status.configureAccess = data.product;
                    $scope.status.routerAttr = getFirstRoot();
                    if ($location.path().split('/').length === 3) {
                        goDefaultRouter();
                    } else {
                        routerForward();
                        // initData().then(function() {
                        //     routerForward();
                        // });
                    }
                });
            }

            /**
             * [routerForward description] 路由重定向
             * @return  {[type]}  [return description]
             */
            function routerForward() {
                var router = $scope.status.routerPathes[3];
                if (router === 'watermarkmanage') {
                    $scope.status.data[$state.params.type].isSelectedTab = true;
                    $scope.status.isSelectedTab = $state.params.type;
                    // $scope.$root.narrowNavigation = true;
                } else {
                    $scope.status.data[$scope.status.routerPathes[3]].isSelectedTab = true;
                }
                if (router !== 'weixin' && router !== 'weibo' && router !== 'trill' && router !== 'baijiahao' && router !== 'qiehao' && router !== 'kuaishou' && router !== 'watermarkmanage') {
                    $scope.status.menuShow = true;
                } else {
                    $scope.$root.narrowNavigation = true;
                }
            }

            /**
             * [goDefaultRouter description]跳转默认
             * @return  {[type]}  [return description]
             */
            function goDefaultRouter() {
                $scope.setTabSelected($scope.status.routerAttr);
                // initData().then(function() {
                //     $scope.setTabSelected($scope.status.routerAttr);
                // });
            }

            /**
             * [getFirstRoot description]
             * @return  {[type]}  [return description]
             */
            function getFirstRoot() {
                var routerAttr = '';
                var index = 0;
                for (var i = 0; i < $scope.status.order.length; i++) {
                    var j = $scope.status.order[i];
                    if ($scope.status.configureAccess[j] && routerAttr === '') {
                        routerAttr = j;
                    }
                    if ($scope.status.configureAccess[j]) {
                        $scope.status.configureAccess[j] = index;
                        index++;
                    }
                }
                $scope.status.mediaNum = index;
                return routerAttr;
            }
        },
    ]);
